import { render } from "./MunicipalityIcon.vue?vue&type=template&id=3faa0302"
const script = {}

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__